<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              :required="true"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ objEmail.emailTitle }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEND_USR')"
              :required="true"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ objEmail.sendUserName }}
            </div>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grdReceiptList"
        :columns="columnEmail"
        :dataset="'dsEmail'"
        :showDisplayCountControl="false"
        :initial-pagesize="10"
        :enabletooltips="true"
        :multiselect="colStatus"
      />
    </div>
    <div
      v-if="receiveType"
      class="comm_btn_wrap mrR30"
    >
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancelClick"
      >
        {{ $t('MSG_BTN_CLOSE') }}
      </sui-button>
    </div>
    <div
      v-if="sendType"
      class="comm_btn_wrap mrR30"
    >
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancelClick"
      >
        {{ $t('MSG_BTN_CLOSE') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onSendCancel"
      >
        {{ $t('MSG_BTN_SEND_CNCL') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMM_00005_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageId: {
      type: String,
      default: 'PGE_CMM_00005',
    },
    emailUid: {
      type: String,
      default: null,
    },
    searchEmailType: {
      type: String,
      default: null,
    },
    emailReceiptUserIdYn: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      objEmail: {
        emailUid: '',
        connectionEmailId: '',
        emailTypeCode: '',
        emailTitle: '',
        sendTemplateId: '',
        emailContent: '',
        sendUserEmail: '',
        emailSendStateCode: '',
        attachDocumentId: '',
        batchJobStateCode: '',
        batchJobRETRYNumberOf: '',
        emailReservationYn: '',
        emailStartDTM: '',
        sendUserName: '',
        emailReceiptUserId: '',
        emailReceiptUserName: '',
        emailReceiptUserCount: '',
      },
      count: 0,
      localdata1: [],
      colStatus: false,
    };
  },
  computed: {
    receiveType() {
      return utils.isEqual(utils.getParameter(this, 'searchEmailType'), 'RECEIVE');
    },
    sendType() {
      return utils.isEqual(utils.getParameter(this, 'searchEmailType'), 'SEND');
    },
  },
  watch: {},
  datasets: [{
    id: 'dsEmail',
    type: 'local',
    datafields: [
      {
        name: 'emailReceiptUserName',
        type: 'string',
        map: 'emailReceiptUserName',
      }, {
        name: 'emailReceiptUserTypeName',
        type: 'string',
        map: 'emailReceiptUserTypeName',
      }, {
        name: 'emailReceiptStatusName',
        type: 'string',
        map: 'emailReceiptStatusName',
      }, {
        name: 'emailReceiptStatusDTM',
        type: 'string',
        map: 'emailReceiptStatusDTM',
      }, {
        name: 'careerLevelName',
        type: 'string',
        map: 'careerLevelName',
      }, {
        name: 'departmentName',
        type: 'string',
        map: 'departmentName',
      }, {
        name: 'receiptUserEmail',
        type: 'string',
        map: 'receiptUserEmail',
      }, {
        name: 'emailReceiptUserId',
        type: 'string',
        map: 'emailReceiptUserId',
      },
    ],
  }],
  created() {
    this.columnEmail = [
      {
        text: this.$t('MSG_TXT_NAME'),
        datafield: 'emailReceiptUserName',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_DIV'),
        datafield: 'emailReceiptUserTypeName',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_CURRENT_STT'),
        datafield: 'emailReceiptStatusName',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_OPEN_DTM'),
        datafield: 'emailReceiptStatusDTM',
      }, {
        text: this.$t('MSG_TXT_CRLV'),
        datafield: 'careerLevelName',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_DEPT'),
        datafield: 'departmentName',
        width: 200,
      }, {
        text: this.$t('MSG_TXT_MAIL_ADDR'),
        datafield: 'receiptUserEmail',
      }, {
        text: this.$t('MSG_TXT_USR_ID'),
        datafield: 'emailReceiptUserId',
        hidden: true,
      },
    ];
  },
  mounted() {
    if (this.searchEmailType !== 'RECEIVE') {
      this.colStatus = true;
      this.$refs.grdReceiptList.showColumn('emailReceiptStatusName', true);
      this.$refs.grdReceiptList.showColumn('emailReceiptStatusDTM', true);
    } else {
      this.$refs.grdReceiptList.showColumn('emailReceiptStatusName', false);
      this.$refs.grdReceiptList.showColumn('emailReceiptStatusDTM', false);
    }
    this.columnEmail.forEach(column => {
      const gridColumn = column;
      if (this.searchEmailType === 'RECEIVE' && column.datafield === 'emailReceiptStatusName') {
        gridColumn.hidden = true;
      }
      if (this.searchEmailType === 'RECEIVE' && column.datafield === 'emailReceiptStatusDTM') {
        gridColumn.hidden = true;
      }
    });
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadData() {
      if (utils.isEmpty(this.emailUid) === false) {
        const dataParams = {
          searchEmailType: this.searchEmailType,
          emailReceiptUserIdYn: this.emailReceiptUserIdYn,
        };
        http.request(this.pageId, 'DTS_CMM_00005', {
          path: {
            'email-uid': this.emailUid,
          },
          query: dataParams,
        }).then(res => {
          // utils.dateformatToClientInArray([res.data], dateTypeFields);
          const newList = [];
          utils.forEach(res.data, data => {
            const result = {};
            // if (data.displayLanguageId !== this.$store.getters.userInfo.langId) {
            //   this.objEmail.emailUid = data.emailUid;
            //   this.objEmail.emailTitle = data.emailTitle;
            //   this.objEmail.sendUserName = data.sendUserGlobalName;

            //   result.emailReceiptUserName = data.emailReceiptUserGlobalName;
            //   result.emailReceiptUserTypeName = data.emailReceiptUserTypeName;
            //   result.careerLevelName = data.careerLevelEnName;
            //   result.departmentName = data.departmentEnglishName;
            //   result.receiptUserEmail = data.receiptUserEmail;
            // } else {
            this.objEmail.emailUid = data.emailUid;
            this.objEmail.emailTitle = data.emailTitle;
            this.objEmail.sendUserName = data.sendUserName;
            console.log(this.$store.getters.userInfo.userId);

            if (this.searchEmailType !== 'SEND') {
              if ((data.emailReceiptUserTypeCode === 'BCC' && data.emailReceiptUserId === this.$store.getters.userInfo.userId) || data.emailReceiptUserTypeCode !== 'BCC') {
                result.emailReceiptUserId = data.emailReceiptUserId;
                result.emailReceiptUserName = data.emailReceiptUserName;
                result.emailReceiptUserTypeName = data.emailReceiptUserTypeName;
                result.emailReceiptStatusName = data.emailReceiptStatusName;
                result.emailReceiptStatusDTM = utils.dateformatToClient(data.emailReceiptStatusDTM);
                result.careerLevelName = data.careerLevelName;
                result.departmentName = data.departmentName;
                result.receiptUserEmail = data.receiptUserEmail;
                const clone = utils.assign(data, result);
                newList.push(clone);
              }
            } else {
              result.emailReceiptUserId = data.emailReceiptUserId;
              result.emailReceiptUserName = data.emailReceiptUserName;
              result.emailReceiptUserTypeName = data.emailReceiptUserTypeName;
              result.emailReceiptStatusName = data.emailReceiptStatusName;
              result.emailReceiptStatusDTM = utils.dateformatToClient(data.emailReceiptStatusDTM);
              result.careerLevelName = data.careerLevelName;
              result.departmentName = data.departmentName;
              result.receiptUserEmail = data.receiptUserEmail;
              const clone = utils.assign(data, result);
              newList.push(clone);
            }
            // }
          });
          this.dsEmail.setRawData(newList);
        }).catch(error => {
          console.log(error);
        });
      }
    },
    onCancelClick() {
      this.$emit('close');
    },
    onSendCancel() {
      const selectedIndexes = this.dsEmail.getSelectedIndexes();
      const emailUidList = [];
      if (selectedIndexes.length < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return false;
      }
      utils.forEach(selectedIndexes, index => {
        emailUidList.push({
          emailUid: this.dsEmail.data[index].emailUid,
          emailReceiptUserId: this.dsEmail.data[index].emailReceiptUserId,
        });
      });
      utils.messageBox('confirm', this.$t('MSG_ALT_SELT_SEND_CNCL'), null, () => {
        // http.requestTest('delete', `/api/v1/common/email/${emailUid}`, {
        http.request(this.contextPageId, 'DTS_CMM_00007', {
          data: emailUidList,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_EMAIL_SEND_CNCL'));
          this.loadData();
        });
      });
      return true;
    },
  },
};
</script>
<style scoped>
</style>
